<template>
  <div class="login-token-view">
    <div class="auth-bg">
      <div class="auth-bg__base"></div>
      <div class="auth-bg__glows"></div>
      <div class="auth-bg__panels"></div>
      <div class="auth-bg__dots"></div>
    </div>
    <div class="content">
      <div class="loading-content">
        <div class="loading-icon">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
          </svg>
        </div>
        <p class="loading-text">{{ loadingText }}</p>
      </div>
    </div>
    <icp></icp>
  </div>
</template>

<script>
import Icp from '../components/common/Icp.vue'
import * as auth from '../api/auth.js'

export default {
  name: "LoginToken",
  components: {
    Icp
  },
  data() {
    return {
      loadingText: '正在连接...',
      loginForm: {
        terminal: this.$enums.TERMINAL_TYPE.WEB,
        username: '',
        ti: '',
        nonce: '',
        sign: '',
        uid: '',
      }
    };
  },
  methods: {
    async submit() {
      this.loadingText = '正在验证...';
      try {
        const data = await this.$http({
          url: "/login-token",
          method: 'post',
          data: this.loginForm
        });
        auth.saveLoginSession(data, {
          autoLogin: false,
          userName: this.loginForm.username
        });
        this.loadingText = '登录成功，正在跳转...';
        // 添加客服好友
        await this.addFriend(this.loginForm.uid);
        // 跳转到聊天页面
        this.$router.push("/home/chat");
      } catch (error) {
        console.error('登录失败:', error);
        this.loadingText = '登录失败，即将返回登录页';
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      }
    },
    async addFriend(friendId) {
      // 先获取好友列表来判断是否已经是好友
      let isAlreadyFriend = false;
      try {
        const friends = await this.$http({ url: '/friend/list' });

        isAlreadyFriend = friends.some(f => f.id === parseInt(friendId) && !f.deleted);
        // console.log('isAlreadyFriend:', isAlreadyFriend);
      } catch (e) {
        console.log('获取好友列表失败:', e);
      }

      if (isAlreadyFriend) {
        console.log('已经是好友，无需添加');
        return;
      }

      try {
        await this.$http({
          url: "/friend/add",
          method: 'post',
          params: {
            friendId: friendId
          }
        });
        console.log('添加好友成功');
      } catch (e) {
        console.log('添加好友失败:', e);
      }
    },
    getUrlParam(name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      const r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    }
  },
  mounted() {
    // 从URL参数获取登录信息
    this.loginForm.username = this.getUrlParam('username') || '';
    this.loginForm.ti = this.getUrlParam('ti') || '';
    this.loginForm.nonce = this.getUrlParam('nonce') || '';
    this.loginForm.sign = this.getUrlParam('sign') || '';
    this.loginForm.uid = this.getUrlParam('uid') || '';

    console.log('loginForm:', this.loginForm);

    if (!this.loginForm.username || !this.loginForm.ti || !this.loginForm.nonce || !this.loginForm.sign || !this.loginForm.uid) {
      this.loadingText = '参数错误，即将返回登录页';
      setTimeout(() => {
        this.$router.push("/login");
      }, 2000);
      return;
    }

    // 执行登录
    this.submit();
  }
}
</script>

<style scoped lang="scss">
.login-token-view {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  background: #fff;
  overflow: hidden;

  .auth-bg {
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  .auth-bg__base,
  .auth-bg__glows,
  .auth-bg__panels,
  .auth-bg__dots {
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  .auth-bg__base {
    background: linear-gradient(135deg,
    #d4e2f8 0%,
    #dce8fa 25%,
    #e6eefb 50%,
    #eef2fc 75%,
    #f8f9fd 100%);
  }

  .auth-bg__glows {
    background-image:
        radial-gradient(ellipse 70% 50% at 85% 15%, rgba(220, 235, 255, 0.6) 0%, transparent 55%),
        radial-gradient(ellipse 60% 45% at 10% 75%, rgba(230, 240, 255, 0.5) 0%, transparent 50%),
        radial-gradient(ellipse 50% 40% at 50% 50%, rgba(255, 255, 255, 0.4) 0%, transparent 45%);
  }

  .auth-bg__dots {
    opacity: 0.4;
    background-image: radial-gradient(circle, rgba(200, 218, 248, 0.35) 1px, transparent 1px);
    background-size: 24px 24px;
  }

  .auth-bg__panels {
    opacity: 0.5;
    background-image:
        repeating-linear-gradient(115deg,
        transparent 0,
        transparent 60px,
        rgba(190, 210, 245, 0.12) 60px,
        rgba(190, 210, 245, 0.12) 65px),
        repeating-linear-gradient(25deg,
        transparent 0,
        transparent 90px,
        rgba(200, 218, 248, 0.08) 90px,
        rgba(200, 218, 248, 0.08) 95px);
  }

  .content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: 1;
  }

  .loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .loading-icon {
    width: 64px;
    height: 64px;
  }

  .spinner {
    animation: rotate 2s linear infinite;
    width: 100%;
    height: 100%;
  }

  .spinner .path {
    stroke: var(--im-color-primary);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }

  .loading-text {
    margin: 0;
    font-size: var(--im-font-size-large);
    color: var(--im-text-color);
  }
}
</style>